const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const API_HOST = API_URL.replace(/\/api\/?$/, '');

export const getMediaUrl = (path?: string | null) => {
  if (!path) return '';
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${API_HOST}${normalized}`;
};




